import React, { memo, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorLoad, Processing } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import StepCSSTransitionGroup from '~/UIKit/StepCSSTransitionGroup/StepCSSTransitionGroup';

import styles from './LazyRoutesContainer.scss';

type IProps = {
  children: React.ReactNode;
};

const LazyRoutesContainer: React.FC<IProps> = ({ children }) => {
  return (
    <ErrorBoundary
      fallbackRender={() => (
        <ErrorLoad
          isFlat
          key="error-load"
          message={t('Произошла ошибка. Повторите попытку позже')}
          onReloadClick={() => window.location.reload()}
        />
      )}
    >
      <Suspense
        fallback={
          <StepCSSTransitionGroup className={styles.spinner} delay={1} distance={0}>
            <Processing isFetching={true} />
          </StepCSSTransitionGroup>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};

export default memo(LazyRoutesContainer);
